import { Card, CardActions, CardContent, Typography } from '@mui/material';
import { memo, ReactElement } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { alphanumericRegex, nameSurnameMoreCharactersAccentsRegex } from 'shell/constants/regex';
import Form from './form';
import { noop } from 'shell/utils/noop';

const validationSchema = yup.object({
  code: yup
    .string()
    .nullable()
    .matches(alphanumericRegex, 'Il campo è alfanumerico')
    .required('Campo obbligatorio'),
  typeRegister: yup.string().nullable().required('Campo obbligatorio'),
  descriptionBrief: yup
    .string()
    .nullable()
    .matches(nameSurnameMoreCharactersAccentsRegex, 'Il campo è alfanumerico'),
  description: yup
    .string()
    .nullable()
    .matches(nameSurnameMoreCharactersAccentsRegex, 'Il campo è alfanumerico'),
});

export interface FormTypePracticeVM {
  code?: string;
  descriptionBrief?: string;
  description?: string;
  typeRegister?: string;
  typeInitiative?: string;
  measure?: string;
  timeStandard?: number;
  timeMax?: number;
}

interface FormTypePracticeProps {
  disabled?: boolean;
  title: string;
  isEdit?: boolean;
  required?: boolean;
  onCancel: () => void;
  initialValues?: FormTypePracticeVM;
  onSubmit?: (values: FormTypePracticeVM) => void;
}

const FormTypePracticeComponent = ({
  disabled,
  title,
  required,
  onCancel,
  isEdit,
  initialValues,
  onSubmit,
}: FormTypePracticeProps): ReactElement => {
  const form = useFormik<FormTypePracticeVM>({
    initialValues: initialValues || {
      code: undefined,
      descriptionBrief: undefined,
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit || noop,
    enableReinitialize: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={form.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2" color="secondary">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Form
              values={form.values}
              onChange={form.setFieldValue}
              disabled={disabled}
              required={required}
              isEdit={isEdit}
              touched={form.touched}
              errors={form.errors}
            />
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel();
            }}
          >
            Annulla
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormTypePracticeComponent.displayName = 'Form Type Practice Page component';

const FormTypePractice = memo(FormTypePracticeComponent);

export default FormTypePractice;
